import { useEffect, useState } from "react";
import { acquireToken } from "../auth/msalClient";
import { BACKEND_API_BASE } from "../env";

type DevCapabilities = {
  devTools?: boolean;
  delegatedTokenProxy?: boolean;
  appTokenProxy?: boolean;
};

async function readJson<T>(response: Response): Promise<T> {
  return (await response.json().catch(() => ({}))) as T;
}

export function useDevToolsAvailability(enabled: boolean) {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function checkCapabilities() {
      setIsAllowed(false);
      try {
        const backendToken = await acquireToken();
        const response = await fetch(`${BACKEND_API_BASE}/api/dev/capabilities`, {
          method: "GET",
          cache: "no-store",
          headers: {
            Authorization: `Bearer ${backendToken}`,
          },
        });
        if (!response.ok || cancelled) return;

        const data = await readJson<DevCapabilities>(response);
        if (data.devTools && (data.delegatedTokenProxy || data.appTokenProxy)) {
          setIsAllowed(true);
        }
      } catch {
        // Dev tools are optional; hide them if the dev route is unavailable.
      }
    }

    if (!enabled) {
      setIsAllowed(false);
      return;
    }

    void checkCapabilities();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return isAllowed;
}
